import { useGlobalSettings } from "src/hooks/use-global-settings.ts";

export const useContentLocale = () => {
  const {
    data: { default_language },
  } = useGlobalSettings();
  return default_language?.locale;
};
